module.exports = __webpack_public_path__ + "img/pap.ec83e522.svg";